export function formatName(first?: string, last?: string): string {
  const f = first?.trim();
  const l = last?.trim();
  if (!f && !l) return '\u2014';
  return `${f ?? ''} ${l ?? ''}`.trim();
}
